module.exports = __webpack_public_path__ + "img/menu-1.577fd128.png";